import axios from "axios";

export class ReadStateService {
    private readStateURL = "/api/v1/readstates";

    async markSupplierEventAsRead(supplierEventID: string): Promise<void> {
        await axios.put(this.readStateURL + "/supplierevent/" + supplierEventID);
    }
}
